export const LOCALE_COOKIE = 'locale';
